import React from "react";
import { Link } from "react-router-dom";
import RankingTile from "../../../common/RankingTile/RankingTile";
import classes from "./TeamRanking.module.scss";
import { RankingTeam } from "@twire/redux/teamRanking/types";
import { getTheme, t } from "@twire/utility/helpers";
import ComponentError from "@twire/common/ComponentError";
import Placeholder from "./Placeholder";
import { ReactComponent as Trophy } from "../../../../assets/svgs/trophy.svg";
import { mergeClasses } from "@twire/utility/helpers";
import { Games } from "@twire/utility/constants";
import { useGetTeamUrl } from "@twire/utility/hooks";
import Text from "@twire/common/Text";

const Ranking: React.FC<{
  topTeams: RankingTeam[];
  loading: boolean;
  updatedAt: string;
  showError: boolean;
  game: Games;
  getTeamUrl: ReturnType<typeof useGetTeamUrl>;
}> = ({ topTeams, loading, updatedAt, showError, game, getTeamUrl }) => (
  <div className={classes.container}>
    <div className={mergeClasses("w-full", classes.left)}>
      <div className={classes.top}>
        <h2>team ranking</h2>
        <p>
          Last updated on:{" "}
          {updatedAt
            ? new Date(Date.parse(updatedAt)).toLocaleDateString()
            : "-- : -- : --"}
        </p>
      </div>
      <div className={mergeClasses("flex items-center", classes.heading)}>
        <div className={classes.rank}>
          <Text i18nKey="words.rank">rank</Text>
        </div>
        <div className={classes.team}>
          <Text i18nKey="words.team">team</Text>
        </div>
        <div className={classes.point}>
          <Text i18nKey="words.rankingPoints">points</Text>
        </div>
        {/* <div className={classes.region}>region</div> */}
      </div>
      {loading ? (
        <Placeholder />
      ) : showError ? (
        <ComponentError
          message={t("sentences.rankingLoadFailed")}
          svg={Trophy}
          suggestion={t("sentences.refreshThePage")}
          className="h-96 mt-4"
        />
      ) : (
        topTeams.map(({ id, name, ranking }, index) => (
          <React.Fragment key={id}>
            <Link to={getTeamUrl(id || 0, name)} className="block my-1">
              <RankingTile
                rank={index + 1}
                team={name}
                theme={getTheme(index)}
                points={String(ranking)}
                game={game}
              />
            </Link>
          </React.Fragment>
        ))
      )}
      <div className={classes.bottom}>
        <h3>How ranking is calculated?</h3>
        <p>
          Team ranking takes into account competitions in the last year. To
          calculate ranking we consider Tier S and some Tier A competitions. All
          tournaments are appropriately weighted according to their tier and
          date. Ranking also includes decay, which means that team score will
          drop over time if they are inactive or if there were some roster
          changes. Ranking is implemented in a way that teams can quickly show
          up among top 100 teams but it is hard to climb top spots and retain
          the position without good performance.
        </p>
      </div>
    </div>
  </div>
);

export default Ranking;
